<script setup lang="ts">
import { ref, onMounted } from 'vue';

const STORAGE_KEY = 'cookie:accepted';
const isVisible = ref(false);

onMounted(() => {
  const accepted = localStorage.getItem(STORAGE_KEY);
  isVisible.value = accepted !== 'true';
});

function accept() {
  localStorage.setItem(STORAGE_KEY, 'true');
  isVisible.value = false;
}
</script>

<template>
  <div
    v-if="isVisible"
    id="spire-cookie-law"
    class="font-[Graphik,system-ui,sans-serif] text-base w-full fixed left-0 text-white z-[9999] box-border h-full top-0 p-0 bg-black/60 flex items-end md:h-auto md:py-6 md:px-[10%] md:bottom-0 md:top-auto md:shadow-[0_0_10px_0_rgba(0,0,0,0.5)] md:bg-black/[0.98] md:block"
  >
    <div
      class="flex flex-col w-full bg-black md:flex-row md:items-center md:justify-between md:max-w-full md:bg-transparent"
    >
      <div class="w-full py-6 px-[5%] box-border leading-relaxed md:flex-1 md:p-0">
        We use cookies on this website to analyse your use of our products and services, provide content from third
        parties and assist with our marketing efforts. Learn more about our use of cookies and available controls:
        <a href="/legal/privacy" target="_blank" class="font-black text-white underline hover:opacity-80"
          >cookie policy</a
        >. Please be aware that your experience may be disrupted until you accept cookies.
      </div>
      <div
        class="w-full py-5 px-[5%] pb-4 m-0 bg-black box-border md:ml-[73px] md:flex-shrink-0 md:w-auto md:p-0 md:bg-transparent"
      >
        <button
          type="button"
          class="w-full m-0 py-[13px] px-6 bg-sw-purple text-white border-none rounded text-base font-semibold cursor-pointer transition-colors duration-200 hover:bg-[#6d6aff] md:w-[190px]"
          @click="accept"
        >
          Accept
        </button>
      </div>
    </div>
  </div>
</template>
